import { Table } from 'antd';
import type { ColumnsType } from 'antd/es/table';
import clsx from 'clsx';
import moment from 'moment';
import React from 'react';

export interface Friend {
  key: string;
  name: string;
  email: string;
  joinDate: string;
  reward: number;
  email_verified_at?: string;
}

const columns: ColumnsType<Friend> = [
  {
    title: 'Name',
    dataIndex: 'name',
    key: 'name',
    render: (name: string) => (
      <div className='flex font-medium'>
        <span className='whitespace-nowrap'>{name}</span>
      </div>
    ),
  },
  {
    title: 'Email',
    dataIndex: 'email',
    key: 'email',
    render: (email: string) => (
      <div className='flex font-medium'>
        <span>{email}</span>
      </div>
    ),
  },
  {
    title: 'Join Date',
    dataIndex: 'joinDate',
    key: 'joinDate',
    render: (joinDate: string) => (
      <div className='flex font-medium whitespace-nowrap'>
        <span>{moment(joinDate).format('DD, MMM YYYY')}</span>
      </div>
    ),
  },
  {
    title: 'Verification',
    dataIndex: 'email_verified_at',
    key: 'email_verified_at',
    render: (email_verified_at: string) => (
      <div
        className={clsx(
          email_verified_at ? 'text-green-600' : 'text-grayZl-700',
          'flex font-medium justify-center whitespace-nowrap text-center',
        )}
      >
        <span>{email_verified_at ? 'Verified' : 'Not Verified'}</span>
      </div>
    ),
  },
];

const rowClassName = (_: any, index: number) => {
  return index % 2 === 0 ? 'bg-cartBgColor' : 'bg-[#282829]';
};
const FriendsJoinedTable: React.FC<{
  data: Friend[];
  loading: boolean;
}> = ({ data, loading }) => {
  return (
    <div>
      <h2
        style={{ color: '#fff' }}
        className='pb-5 overflow-x-auto text-2xl font-semibold'
      >
        Friends Joined
      </h2>
      <Table
        columns={columns}
        dataSource={data}
        loading={loading}
        className='rounded-xl overflow-x-auto'
        pagination={false}
        rowClassName={rowClassName}
        style={{
          backgroundColor: '#292929',
          borderRadius: '12px',
          overflowX: 'auto',
          scrollbarWidth: 'thin',
          scrollbarColor: 'white #1A1A1A',
        }}
      />
    </div>
  );
};

export default FriendsJoinedTable;
